module.exports = __webpack_public_path__ + "img/fig07.5be50edf.jpg";